import classNames from "classnames";
import React, { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import {
  dayOptions,
  expirationYearsOptions,
  monthOptions,
  yearOptions,
} from "shared/lib/functions";
import { formattedMessageParams } from "shared/messages";

import { Select } from "@components/Profile/Forms/HooksForm";

const { dayText, monthText, yearText } = defineMessages({
  dayText: formattedMessageParams("Date.day"),
  monthText: formattedMessageParams("Date.month"),
  yearText: formattedMessageParams("Date.year"),
});

export default function DateInput({
  value,
  onChange,
  yearsFromNow,
  required,
  error,
  showTop,
  className,
  touch,
  touched,
}: {
  value?: string;
  onChange: () => void;
  yearsFromNow?: boolean;
  required?: boolean;
  error: boolean;
  showTop?: boolean;
  className?: string;
  touch: () => void;
  touched: boolean;
}) {
  const intl = useIntl();
  const lang = useSelector((state) => state.requestorConfig.currentLanguage);
  const [year = "", month = "", day = ""] = (value || "").split("-");
  const isFilled = touched && className;

  useEffect(() => {
    if (year && month && day) touch();
  }, [year, month, day, touch]);

  return (
    <div
      className={classNames("custom-input-wrapper", {
        "input-wrapper-required": required,
        "input-wrapper-error": error && touched,
      })}
    >
      <div className="profile-input-date-container">
        <div className="date-input-field date-input-field-day">
          <Select
            showTop={showTop}
            className={isFilled}
            options={dayOptions()}
            placeholder={intl.formatMessage(dayText)}
            value={day}
            setter={(newDay) => onChange(`${year}-${month}-${newDay}`)}
          />
        </div>
        <div className="date-input-field date-input-field-month">
          <Select
            showTop={showTop}
            className={isFilled}
            options={monthOptions(lang)}
            placeholder={intl.formatMessage(monthText)}
            value={month}
            setter={(newMonth) => onChange(`${year}-${newMonth}-${day}`)}
          />
        </div>
        <div className="date-input-field-year">
          <Select
            showTop={showTop}
            className={isFilled}
            options={!yearsFromNow ? yearOptions() : expirationYearsOptions()}
            placeholder={intl.formatMessage(yearText)}
            value={year}
            setter={(newYear) => onChange(`${newYear}-${month}-${day}`)}
          />
        </div>
      </div>
    </div>
  );
}
